import { CONST } from './constants';
import { itrState, itrAction } from 'store/initialState';

export default (
  state: itrState,
  action: itrAction,
): { [key: string]: (act: itrAction) => itrState } => {
  const reducer = {
    [CONST.SIGNIN_CLICK](act: itrAction) {
      return {
        ...state,
        signinClicked: !state.signinClicked,
      };
    },
  };
  return reducer;
};
